import React from "react";

import cx from "classnames";

import { Tooltip } from "~/ui";

import styles from "./RedactionMarker.module.css";

const MarkerImage = React.forwardRef<SVGSVGElement, { selected: SelectedState; className?: string }>(
	function MarkerImage({ selected, className }, ref) {
		const start = selected === "selecting-start" || selected === "start";
		const path = start
			? // eslint-disable-next-line max-len
				"M3.25 1.375C2.21447 1.375 1.375 2.21447 1.375 3.25V10.75C1.375 11.7855 2.21447 12.625 3.25 12.625H19.2164C20.8343 12.625 21.6927 10.7135 20.6178 9.50432L13.9512 2.00432C13.5954 1.60403 13.0854 1.375 12.5498 1.375H3.25Z"
			: // eslint-disable-next-line max-len
				"M3.25 12.625C2.21447 12.625 1.375 11.7855 1.375 10.75V3.25C1.375 2.21447 2.21447 1.375 3.25 1.375H19.2164C20.8343 1.375 21.6927 3.28649 20.6178 4.49568L13.9512 11.9957C13.5954 12.396 13.0854 12.625 12.5498 12.625H3.25Z";

		const isActive = selected === "start" || selected === "end";
		return (
			<svg
				ref={ref}
				width="22"
				height="14"
				viewBox="0 0 22 14"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
				className={cx(styles.markerImage, { [styles.isActive]: isActive }, className)}
			>
				<path d={path} />
			</svg>
		);
	},
);

export type SelectedState = "selecting-start" | "start" | "selecting-end" | "end" | "not-allowed";
interface RedactionMarkerProps {
	selected: SelectedState;
	onClick?: React.MouseEventHandler;
	className?: string;
}

export function RedactionMarker(props: RedactionMarkerProps) {
	const tooltipText =
		props.selected === "selecting-start"
			? "Start redacting"
			: props.selected === "selecting-end"
				? "End redacting"
				: null;

	const hidden = props.selected === "not-allowed";

	return (
		<Tooltip content={tooltipText} disabled={!tooltipText}>
			<button className={cx(styles.button, { [styles.hidden]: hidden })} onClick={props.onClick}>
				<MarkerImage selected={props.selected} className={props.className} />
			</button>
		</Tooltip>
	);
}
